import bounceApiClient from './utils/bounceApiClient';

export async function uploadImage({ blob }: { blob: Blob }) {
  const formData = new FormData();
  formData.append('image', blob);

  const { data } = await bounceApiClient.post(`/api/uploads/images`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return data;
}
